import { gql } from '@apollo/client';

/**
 * GraphQL mutation for deleting a community
 */
export const DELETE_COMMUNITY = gql`
  mutation DeleteCommunity($id: ID!) {
    deleteCommunity(id: $id) {
      success
      message
    }
  }
`;
